module.exports = __webpack_public_path__ + "static/media/icn-send-inactive.97e1dd31.svg";